module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_launchAnimate'),
      "name": _vm.$t('app_launchAnimate')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_onLogo'),
      "name": _vm.$t('app_onLogo')
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('app_deskwp'),
      "name": _vm.$t('app_deskwp')
    }
  })], 1)], 1), _vm._v(" "), (_vm.mode === this.$t('app_launchAnimate')) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "name": "main"
    }
  }, [_c('el-form', {
    ref: "fm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules,
      "label-width": "12.5%",
      "model": _vm.fm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_animateName')
    },
    model: {
      value: (_vm.fm.name),
      callback: function($$v) {
        _vm.$set(_vm.fm, "name", $$v)
      },
      expression: "fm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_playPlace'),
      "prop": "playPlace"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.fm.playPlace),
      callback: function($$v) {
        _vm.$set(_vm.fm, "playPlace", $$v)
      },
      expression: "fm.playPlace"
    }
  }, _vm._l((_vm.playPlace), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_animatefile'),
      "prop": "aFile"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.srcBefore,
      "on-success": _vm.srcSuccess,
      "file-list": _vm.srcList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm', '1')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === this.$t('app_onLogo')),
      expression: "mode === this.$t('app_onLogo')"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "fm1",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules1,
      "label-width": "12.5%",
      "model": _vm.fm1
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "logo"
    },
    model: {
      value: (_vm.fm1.name),
      callback: function($$v) {
        _vm.$set(_vm.fm1, "name", $$v)
      },
      expression: "fm1.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO",
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "*",
      "name": "fileUpload",
      "action": _vm.fileUploadUrl,
      "before-upload": _vm.picBefore,
      "on-success": _vm.picSuccess1,
      "on-error": _vm.picError1,
      "file-list": _vm.picList1
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#C0CCDA"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_plsinputimgfile')))])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm1', '2')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === this.$t('app_deskwp')),
      expression: "mode === this.$t('app_deskwp')"
    }],
    staticClass: "gPageBorder"
  }, [_c('el-form', {
    ref: "fm2",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.addArules2,
      "label-width": "12.5%",
      "model": _vm.fm2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_name'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_deskwp')
    },
    model: {
      value: (_vm.fm2.name),
      callback: function($$v) {
        _vm.$set(_vm.fm2, "name", $$v)
      },
      expression: "fm2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_pic'),
      "prop": "pic"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "accept": "image/*",
      "name": "file",
      "action": _vm.imgUploadUrl,
      "before-upload": _vm.picBefore,
      "on-success": _vm.picSuccess2,
      "on-error": _vm.picError2,
      "file-list": _vm.picList2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_clickUpdate')))]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#C0CCDA"
    }
  }, [_vm._v(_vm._s(_vm.$t('app_plsUpl')) + " " + _vm._s(_vm.$t('app_pic')) + " (jpg/png, 720x1280)")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addAnimate('fm2', '3')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_customs')))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5a244a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/onoff/addAnimate.vue
// module id = 1123
// module chunks = 0